import { CustomDateFormatPipe } from '../../../../../_helpers/_pipes/custom-date-format.pipe';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbFormsModule, MapfreButtonComponent, CustomDateFormatPipe],
  selector: 'app-bn-transaction-history',
  templateUrl: './bn-transaction-history.component.html',
  styleUrls: ['./bn-transaction-history.component.scss']
})
export class BnTransactionHistoryComponent implements OnInit, OnChanges {
  @ViewChild('fromDate', { static: false }) fromDate: ElementRef;
  @ViewChild('toDate', { static: false }) toDate: ElementRef;
  @Input() policy: any;
  transactionFormGroup: FormGroup;
  transactions: any;
  nextBill: any;
  showLoadTransaction: boolean;
  loadedTransactions: any;
  remainingTransactions: any;
  filteredTransaction: boolean;
  totalTransactions: any;
  buttonEnabled: boolean;
  isAcmic: boolean;
  isIOS: boolean;

  constructor(private router: Router, private acmicService: AcmicService) {
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  }

  getLatestScheduledBill() {
    if (this.policy.scheduleBills) {
      this.nextBill = this.policy.scheduleBills
        .filter((e) => {
          return e.invoiceState == 'Planned';
        })
        .sort(function compare(a, b) {
          const dateA: any = new Date(a.dateDue);
          const dateB: any = new Date(b.dateDue);
          return dateA - dateB;
        })[0];
    } else {
      this.nextBill = null;
    }
  }

  loadTransactions() {
    this.remainingTransactions = this.remainingTransactions - 4;
    this.viewLoadTransaction();
    this.transactions = this.totalTransactions.slice(
      0,
      this.totalTransactions.length - this.remainingTransactions
    );
  }

  viewLoadTransaction() {
    if (this.remainingTransactions > 0) {
      this.showLoadTransaction = true;
    } else {
      this.showLoadTransaction = false;
    }
  }

  goToFAQ() {
    this.router.navigate(['/faq']);
  }

  goToDocuments() {
    this.router.navigate([
      '/my-insurance',
      this.policy.policynumber.policyNumber,
      'documents',
    ]);
  }

  filterTransactions() {
    this.transactions = this.policy.transactions
      .filter((transaction) => {
        return (
          transaction.transactionDate >= this.fromDate.nativeElement.value &&
          transaction.transactionDate <= this.toDate.nativeElement.value
        );
      })
      .reverse();
    this.calculateTransaction(this.transactions, this.transactions.length);
  }

  calculateTransaction(transaction, count) {
    this.remainingTransactions = count - 4;
    this.totalTransactions = transaction.slice();
    this.transactions = transaction.slice(0, 4);
    this.viewLoadTransaction();
  }

  openDatePicker(inputType: 'from' | 'to', event?: MouseEvent) {
    const inputRef = inputType === 'from' ? this.fromDate : this.toDate;
    const input: HTMLInputElement | undefined = inputRef?.nativeElement;
    if (!input || event?.target === input) {
      return;
    }

    if (typeof input.showPicker === 'function') {
      try {
        input.showPicker();
        event?.preventDefault();
        return;
      } catch {
        // Safari versions without date-picker support use native label activation below.
      }
    }

    input.focus();
    // Keep the label's default activation trusted on iOS instead of synthesizing a click.
    if (!event) {
      input.click();
    }
  }

  compareDates() {
    const fromDate = this.fromDate.nativeElement.value.replace(/\D/g, '');
    const toDate = this.toDate.nativeElement.value.replace(/\D/g, '');
    if (fromDate > toDate) {
      this.buttonEnabled = false;
    } else {
      this.buttonEnabled = true;
    }
  }

  setFormGroup() {
    this.transactionFormGroup = new FormGroup({
      fromDate: new FormControl('', Validators.required),
      toDate: new FormControl('', Validators.required),
    });
  }

  transactionData() {
    let transactions: [] = null;
    if (this.policy.transactions) {
      transactions = this.policy.transactions.slice();
      this.transactions = transactions.slice().reverse();
    }
    if (this.transactions && this.transactions.length > 4) {
      this.showLoadTransaction = true;
    } else {
      this.showLoadTransaction = false;
    }
    this.loadedTransactions = 4;
    if (this.transactions) {
      this.calculateTransaction(this.transactions, this.transactions.length);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['policy']) {
      this.transactionData();
    }
  }

  ngOnInit(): void {
    this.getLatestScheduledBill();
    this.setFormGroup();
    this.isAcmic = this.acmicService.isACMIC();
    this.transactionData()
  }
}

